module.exports.run = (object, keys) => {
  return keys.reduce((acc, key) => {
    if(typeof object[key] !== 'undefined'){
      acc[key] = object[key];
    }
    return acc;
  }, {});
};